import * as Yup from "yup";

const TeamTypeSchema = Yup.object().shape({
  descripcion: Yup.string().required("Este campo es requerido"),
});

export default TeamTypeSchema;
